import { render, staticRenderFns } from "./Klappläden.vue?vue&type=template&id=10252d47&"
import script from "./Klappläden.vue?vue&type=script&lang=js&"
export * from "./Klappläden.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports